//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'

import { uniqueId } from 'utils/strings'
import colors from 'components/utils/colors'
import TableCell from 'components/Shared/TableNew/TableCell'
import IconLink from 'components/Shared/IconLink/Index'
import Tooltip from 'components/Shared/Tooltip/Index'
import EllipsisTooltip from 'components/Shared/EllipsisTooltip/Index'

const WIDTH = 304
const StyledTableFormLabelCell = styled(TableCell)`
  width: ${WIDTH}px;
  max-width: ${WIDTH}px;
  min-width: ${WIDTH}px;
  font-size: 14px;
  font-family: Exo;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
  color: ${colors.secondary20};
  vertical-align: top;
  padding: 17px 0 0 16px;
`

const CellContent = styled.div`
  display: flex;
  align-items: center;

  & > div[role="tooltip"] {
    text-transform: none;
  }
`

const StyledRequiredIcon = styled.div`
  background-color: ${colors.alert};
  border-radius: 50%;
  width: 8px;
  min-width: 8px;
  height: 8px;
  margin-left: 4px;
`

const StyledHelpIcon = styled(IconLink)`
  margin-left: 4px;
`

const renderHelpIcon = (tooltip) => {
  const tooltipId = uniqueId()
  if (!tooltip) {
    return null
  }

  return (
    <>
      <Tooltip id={tooltipId} />
      <StyledHelpIcon
        data-tooltip-content={tooltip}
        data-tooltip-id={tooltipId}
        iconName='icon-help-16'
      />
    </>
  )
}

const TableFormLabelCell = ({ children, tooltip, required }) => {
  return (
    <StyledTableFormLabelCell>
      <CellContent data-test='form-label-cell'>
        <EllipsisTooltip>
          {children}
        </EllipsisTooltip>

        {renderHelpIcon(tooltip)}
        {required && <StyledRequiredIcon />}
      </CellContent>
    </StyledTableFormLabelCell>
  )
}

TableFormLabelCell.propTypes = {
  children: PropTypes.node,
  tooltip: PropTypes.string,
  required: PropTypes.bool,
}

export default TableFormLabelCell
